"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _d = _interopRequireDefault(require("../../lib/d3"));

var _chart = _interopRequireDefault(require("./chart"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var PieChart = /*#__PURE__*/function (_Chart) {
  _inherits(PieChart, _Chart);

  var _super = _createSuper(PieChart);

  function PieChart() {
    _classCallCheck(this, PieChart);

    return _super.apply(this, arguments);
  }

  _createClass(PieChart, [{
    key: "init",
    value: function init() {
      _get(_getPrototypeOf(PieChart.prototype), "init", this).call(this);

      this.layout = _d.default.pie().value(this.valueAccessor);
    }
  }, {
    key: "initDOM",
    value: function initDOM() {
      var _this$params = this.params,
          margins = _this$params.margins,
          chartClass = _this$params.chartClass,
          resizable = _this$params.resizable;
      var _this$dimensions = this.dimensions,
          width = _this$dimensions.width,
          height = _this$dimensions.height;
      this.svg = _d.default.select(this.container).append('svg').attr('class', ['pie-chart', chartClass].join(' ')).attr('transform-origin', '0 0 0');
      this.g = this.svg.append('g');

      if (!resizable) {
        this.fitToSize();
      } // path group


      this.arcGroup = this.g.append('g').attr('class', 'arcs');
    }
  }, {
    key: "fitToSize",
    value: function fitToSize() {
      var margins = this.params.margins;
      var _this$dimensions2 = this.dimensions,
          width = _this$dimensions2.width,
          height = _this$dimensions2.height;
      var radius = Math.min(width, height) / 2;
      this.g.attr('transform', "translate(".concat(margins.left + width / 2, ", ").concat(margins.top + height / 2, ")"));
      this.svg.attr('width', width + margins.left + margins.right).attr('height', height + margins.top + margins.bottom);
      this.arcGenerator = _d.default.arc().innerRadius(this.innerRadius(radius)).outerRadius(this.outerRadius(radius)).padAngle(0.01);
    }
  }, {
    key: "update",
    value: function update(data) {
      if (!data || !data.length) {
        return;
      }

      this.data = this.preTransformData(data);
      this.draw();
    }
  }, {
    key: "innerRadius",
    value: function innerRadius(radius) {
      return radius / 2.5;
    }
  }, {
    key: "outerRadius",
    value: function outerRadius(radius) {
      return radius;
    }
  }, {
    key: "draw",
    value: function draw() {
      var _this = this;

      var resizable = this.params.resizable;

      if (resizable) {
        this.fitToSize();
      }

      this.arcs = this.arcGroup.selectAll('path.arc').data(this.layout(this.data));
      this.arcsExit = this.arcs.exit().remove();
      this.arcsEnter = this.arcs.enter().append('path').attr('class', 'arc');
      this.arcs = this.arcGroup.selectAll('path.arc').attr('d', function (d) {
        return _this.arcGenerator(d);
      });
    }
  }]);

  return PieChart;
}(_chart.default);

exports.default = PieChart;